module.exports = __webpack_public_path__ + "static/assets/b48fe171efe21f59fcb4536c038d088a.svg";